export const initGallerySwiper = () => {
	const galleryContainers = document.querySelectorAll('.gallery-swiper');
	if (!galleryContainers.length) return;

	galleryContainers.forEach((container) => {
		const swiperEl = container.querySelector('.swiper');
		const pagination = container.querySelector('.gallery-pagination');
		const nextBtn = container.querySelector('.gallery-next');
		const prevBtn = container.querySelector('.gallery-prev');

		if (!swiperEl) return;

		new Swiper(swiperEl, {
			slidesPerView: 1,
			spaceBetween: 10,
			loop: false,
			pagination: {
				el: pagination,
				clickable: true,
			},
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
			},
			breakpoints: {
				640: {
					slidesPerView: 1.5,
					spaceBetween: 10,
				},
				768: {
					slidesPerView: 2.5,
					spaceBetween: 10,
				}
			},
		});
	});
};
